import React from 'react';
import { Carousel, Spin } from 'antd';
import { ImageLoadingObject } from '@common-types';
import { IImage } from '@share/common-types';
import './style.scss';

interface IProps {
  images: IImage[];
}

interface IState {
  failedImages: string[];
  imagesMap: ImageLoadingObject;
}

const speed = 500;
const slidesToShow = 1;
const slidesToScroll = 1;

export class CondoCarouselHotelImages extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      failedImages: [],
      imagesMap: this.generateImagesMap(),
    };
  }

  generateImagesMap = (): ImageLoadingObject => {
    return this.props.images.reduce((res: ImageLoadingObject, img: IImage, index: number) => {
      res[index] = {
        img,
        loading: true,
      };

      return res;
    }, {} as ImageLoadingObject);
  };

  componentDidUpdate(prevProps: Readonly<IProps>): void {
    if (prevProps.images !== this.props.images) {
      this.setState({ imagesMap: this.generateImagesMap() });
    }
  }

  addFailedImage = (src: string): void => {
    this.setState((prevState: IState) => {
      return {
        failedImages: [...prevState.failedImages, src],
      };
    });
  };

  onImageLoad = (index: number): void => {
    this.setState((prevState: IState) => {
      return {
        ...prevState,
        imagesMap: {
          ...prevState.imagesMap,
          [index]: {
            ...prevState.imagesMap[index],
            loading: false,
          },
        },
      };
    });
  };

  render(): React.ReactNode {
    const propsCarousel = {
      dots: false,
      infinite: true,
      arrows: true,
      speed,
      slidesToShow,
      slidesToScroll,
    };
    const { images } = this.props;
    const { imagesMap, failedImages } = this.state;

    if (!images) {
      return null;
    }

    return (
      <Carousel {...propsCarousel} lazyLoad="ondemand">
        {images.map((image: IImage, i: number) => {
          if (failedImages.includes(image.url)) {
            return null;
          }

          return (
            <div className="condo-custom-carousel-image" key={i}>
              <div
                className="condo-custom-carousel-image__spinner"
                style={{
                  display: imagesMap[i]?.loading ? 'flex' : 'none',
                }}
              >
                <Spin />
              </div>
              <img
                style={{ display: imagesMap[i]?.loading ? 'none' : 'block' }}
                className="condo-custom-carousel-image__item"
                src={image.url}
                alt={image.description}
                onLoad={() => this.onImageLoad(i)}
                onError={() => this.addFailedImage(image.url)}
              />
            </div>
          );
        })}
      </Carousel>
    );
  }
}
